<div class="errwrap">
  <div class="errdiv1" id="errs">
  </div>
</div>
<div *ngIf="actionmode=='Add' || actionmode=='Edit'" class="searchdiv">
  <div class="card screen-wrapper">
    <div class="header headerdiv">
      <h1 class="screen-title">{{screentitle}}</h1>
      <div class="button-wrapper bothbuttdiv2">
        <div *ngIf="actionmode=='Add' || actionmode=='Edit'" class="btn back-button button-margin ">
          <button [disabled]="nameExistBN|| showList==true || viewpage==true || invalidCityName || onlyspclchar || onlynum || exceedLength || notAlphabet || minlength || cnameExceed || mincityname || onlynumc 
                || bannerCodeNotAlphaNumeric || bannerCodeMinLengthBN" class="btn btn-primary commonbutt" type="button"
            (click)="submitData()">
            <em class="fa fa-check"></em>&nbsp;Submit </button>
          <button class="btn btn-danger commonbutt" (click)="searchForm()" type="button">
            <em class="fa fa-times"></em>&nbsp;Close</button>
        </div>
      </div>
    </div>

    <div class="card-body">
      <div class="row">
        <div class="col-md-12">
          <div class="form-div">
            <div class="row">
              <div class="m-portlet">
                <div>
                  <div>
                    <div>
                      <div class="errdiv1">
                        <p class="text-danger" style="text-align: center" id="err"></p>
                      </div>
                      <div class="col-lg-3">
                        <label>Platform</label>
                        <select class="form-control" [(ngModel)]="screen_details.platform"
                          (change)="onChangeHandler($event.target.value, 'platform',actionmode =='Edit')"
                          [(ngModel)]="screen_details.platform">
                          <option value="" selected>--Select Banner Page--</option>
                          <option *ngFor="let p of platform" value={{p.id}}>
                            {{p.value}}
                          </option>
                        </select>
                      </div>
                      <div class="col-lg-3">
                        <label>Trip Type</label>
                        <select class="form-control"
                          (change)="onChangeHandler($event.target.value, 'TripType',actionmode =='Edit')"
                          [(ngModel)]="screen_details.TripType">
                          <option value="">--Select Flight Type--</option>
                          <option *ngFor="let flight of TripType" value={{flight.id}}>
                            {{flight.value}}
                          </option>
                        </select>
                      </div>
                      <div class="col-lg-3">
                        <label>Journey Type</label>
                        <select class="form-control" (change)="onChangeHandler($event.target.value, 'journeyType', 
                          actionmode =='Edit')" [(ngModel)]="screen_details.journeyType">
                          <option value="">--Select Journey Type--</option>
                          <option *ngFor="let journey of JourneyType" value={{journey.id}}>
                            {{journey.value}}
                          </option>
                        </select>
                      </div>
                      <div class="col-lg-3">
                        <label>Display</label>
                        <select class="form-control" [disabled]="displayDisable" [(ngModel)]="screen_details.pageId"
                          (change)="onChangeHandler($event.target.value, 'pageId', 
                          actionmode =='Edit')">
                          <option value="">--Select Banner Page--</option>
                          <option *ngFor="let bannerPage of bannerPages" value={{bannerPage.id}}>
                            {{bannerPage.pageName}}
                          </option>
                        </select>
                      </div>
                      <div class="col-lg-3">
                        <label>Form Factor</label>
                        <select class="form-control" [(ngModel)]="screen_details.formFactor" (change)="onChangeHandler($event.target.value, 'formFactor', 
                          actionmode =='Edit')">
                          <option value="">--Select Platform --</option>
                          <option value="1">Web</option>
                          <option value="0">Mobile</option>
                        </select>
                      </div>
                      <div class="col-lg-3">
                        <label>Section Name</label>
                        <select class="form-control" [(ngModel)]="screen_details.sectionId" [disabled]="sectionDisable"
                          (change)="onChangeHandler($event.target.value, 'sectionId', actionmode =='Edit')">
                          <option value="">--Select Section Name --</option>
                          <option *ngFor="let pageSection of pageSections" value={{pageSection.id}}>
                            {{pageSection.sectionName}}
                          </option>
                        </select>
                        <span *ngIf="nameExistBN" style="color: red">Banner Name already exist</span>
                      </div>
                      <div class="col-lg-3">
                        <label class="">Banner Alt Image text</label>
                        <input class="form-control" type="text" name="imageAlt"
                          (keyup)="onChangeHandler($event.target.value, 'bannerAltImage',actionmode =='Edit')"
                          value="{{screen_details.bannerAltImage}}" placeholder="Please Enter Banner Image Alt Text" />
                      </div>
                      <div class="col-lg-3">
                        <label class="">Banner Link</label>
                        <input class="form-control" type="text" name="imageAlt"
                          (keyup)="onChangeHandler($event.target.value, 'contentLink',actionmode =='Edit')"
                          value="{{screen_details.contentLink}}" placeholder="Please Enter Content url" />
                      </div>
                      <div class="col-lg-3">
                        <label class="">Banner Redirection</label>
                        <select class="form-control" [(ngModel)]="screen_details.isNewTab"
                          (change)="onChangeHandler($event.target.value, 'isNewTab', actionmode =='Edit')">
                          <option value="">--Select Redirection type --</option>
                          <option value="1">New Tab</option>
                          <option value="0">Same Tab</option>
                        </select>
                      </div>
                      <div class="col-lg-3">
                        <label class="">Banner Position</label>
                        <input class="form-control" type="number" name="bannerPosition" min="1"
                          (input)="onChangeHandler($event.target.value, 'position', actionmode =='Edit')"
                          value="{{screen_details.position}}" placeholder="Please enter Banner Position" />
                      </div>
                      <div class="col-lg-3">
                        <label class="">Banner Status</label>
                        <select class="form-control" [(ngModel)]="screen_details.isContentActive"
                          (change)="onChangeHandler($event.target.value, 'isContentActive', actionmode =='Edit')">
                          <option value="">--Select Banner Status --</option>
                          <option value="1">Active</option>
                          <option value="0">Inactive</option>
                        </select>
                      </div>
                      <div class="col-lg-3">
                        <label *ngIf="isSearchWidget == false" class="">Banner Image</label>
                        <input type="file" name="file" [disabled]="showList==true"
                          (change)="getFileDetails($event,'not-login')" ng2FileSelect [uploader]="uploader"
                          class="form-control">
                      </div>
                      <div *ngIf="screen_details.bannerImage !=''">
                        <img [src]="getImage(screen_details.bannerImage)" width="100px" height="95px"
                          alt="Banner Image">
                      </div>

                      <div class="clr"></div>
                      <div class="divider">
                      </div>

                      <div class="col-lg-12">
                        <div class="col-lg-6">
                          <label class="">Banner Heading</label>
                          <app-tiny-editor [elementId]="'contentHeading'"
                            (onContentChange)="keyupHandler($event, 'contentHeading')"
                            [editedData]="screen_details.contentHeading">
                          </app-tiny-editor>
                        </div>
                      </div>

                      <div class="col-lg-12" style="margin-top: 28px">
                        <div class="col-lg-6">
                          <label class="">Banner SubHeading</label>
                          <app-tiny-editor [elementId]="'contentSubHeading'"
                            (onContentChange)="keyupHandler($event, 'contentSubHeading')"
                            [editedData]="screen_details.contentSubHeading">
                          </app-tiny-editor>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<div *ngIf="actionmode!='Add' && actionmode!='Edit' && actionmode!='View'" class="searchdiv">
  <div>
    <div class="headerdiv">
      <h1>
        Content Search
      </h1>
      <div class="bothbuttdiv">
        <button class="btn btn-primary commonbutt" *ngIf="RAC_ADD_BN =='1'" type="button" (click)="addForm()">
          <em class="fa fa-plus-circle"></em>&nbsp;Add New</button>
      </div>
    </div>
    <div class="card-body">
      <div class="row">
        <div class="col-md-12">
          <div class="form-div">
            <div class="row">
              <div class="m-portlet">
                <div>
                  <div>
                    <div class="wr15">
                      <div class="instruct">
                        <div class="int1" style="margin-left: 17px">
                          <span class="inst" style="font-size: 12px"><strong> Instructions </strong></span>
                          <br />
                          <span class="txt">
                            1. To Search You need to select atleast one value
                          </span>
                          <br />
                          <span class="txt">
                            2. You can also use a combination of the given fields to search </span>
                          <br />
                          <span></span>
                          <span class="txt">
                            3. To Enable Display You need to select Platform, Trip Type, Journey Type</span>
                          <br />
                          <span></span>
                          <span class="txt">
                            4. To Enable Section Name You need to select All values</span>
                          <br />
                          <span></span>
                        </div>
                      </div>
                      <div class="col-lg-3">
                        <label>Platform</label>
                        <select class="form-control"
                          (change)="onChangePageInfo($event.target.value, 'platform', 'search_details')"
                          [(ngModel)]="search_details.platform">
                          <option value="">--Select Platform--</option>
                          <option *ngFor="let banner of platform" value={{banner.id}}>
                            {{banner.value}}
                          </option>
                        </select>
                      </div>
                      <div class="col-lg-3">
                        <label>Trip Type</label>
                        <select class="form-control"
                          (change)="onChangePageInfo($event.target.value, 'TripType', 'search_details')"
                          [(ngModel)]="search_details.TripType">
                          <option value="">--Select Flight Type--</option>
                          <option *ngFor="let flight of TripType" value={{flight.id}}>
                            {{flight.value}}
                          </option>
                        </select>
                      </div>
                      <div class="col-lg-3">
                        <label>Journey Type</label>
                        <select class="form-control"
                          (change)="onChangePageInfo($event.target.value, 'journeyType', 'search_details')"
                          [(ngModel)]="search_details.journeyType">
                          <option value="">--Select Journey Type--</option>
                          <option *ngFor="let journey of JourneyType" value={{journey.id}}>
                            {{journey.value}}
                          </option>
                        </select>
                      </div>
                      <div class="col-lg-3">
                        <label>Display</label>
                        <select class="form-control" [disabled]="displayDisable"
                          [(ngModel)]="search_details.bannerPageId"
                          (change)="onChangePageSearch($event.target.value, 'display','search_details')">
                          <option value="">--Select Banner Page--</option>
                          <option *ngFor="let bannerPage of bannerPages" value={{bannerPage.id}}>
                            {{bannerPage.pageName}}
                          </option>
                        </select>
                      </div>
                      <div class="col-lg-3">
                        <label>Form Factor</label>
                        <select class="form-control" [(ngModel)]="search_details.formFactor"
                          (change)="onChangePageSearch($event.target.value, 'formFactor', 'search_details', 'bannerPageId')">
                          <option value="">--Select Form Factor--</option>
                          <option value="1">Web</option>
                          <option value="0">Mobile</option>
                        </select>
                      </div>
                      <div class="col-lg-3">
                        <label>Section Name</label>
                        <select class="form-control" [disabled]="sectionDisable" [(ngModel)]="search_details.sectionId">
                          <option value="">--Select Banner Name--</option>
                          <option *ngFor="let pageSection of pageSections" value={{pageSection.id}}>
                            {{pageSection.sectionName}}
                          </option>
                        </select>
                      </div>
                    </div>
                  </div>
                  <div class="btn clear-button button-margin">
                    <button class="btn btn-primary commonbutt" (click)="searchData()" type="button"
                      style="margin-top:23px">
                      <em class="fa fa-search "></em>&nbsp;Search</button>
                  </div>
                </div>
                <div class="errwrap">
                  <div class="errdiv1" id="err">

                  </div>
                </div>
                <div *ngIf="searchresult" class="reportstatus" [hidden]="searchlistBN">
                  <table aria-describedby="bannerDetails" class="table table-striped" *ngIf="!loader"
                    [mfData]="serachtabledataBN" [mfRowsOnPage]="5">
                    <thead>
                      <tr>
                        <th scope="col" style="width: 20%" *ngIf="RAC_VIEW_BN =='1' || RAC_EDIT_BN =='1'">
                          Actions
                        </th>
                        <th scope="col" style="width: 20%">
                          <mfDefaultSorter by="REGION_CODE">Display Page</mfDefaultSorter>
                        </th>
                        <th scope="col" style="width: 20%">
                          <mfDefaultSorter by="REGION_NAME">Section Name</mfDefaultSorter>
                        </th>
                        <th scope="col" style="width: 20%">
                          <mfDefaultSorter by="REGION_NAME">Banner Type</mfDefaultSorter>
                        </th>
                        <th scope="col" style="width: 20%">
                          <mfDefaultSorter by="PLATFORM">Platform</mfDefaultSorter>
                        </th>
                        <th scope="col" style="width: 20%">
                          <mfDefaultSorter>Status</mfDefaultSorter>
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let item of serachtabledataBN | paginate: { itemsPerPage: 10, currentPage: p }">
                        <td *ngIf="RAC_VIEW_BN =='1' || RAC_EDIT_BN =='1'">
                          <button class="btn btn-default btn-circle" *ngIf="RAC_VIEW_BN =='1'" type="button"
                            (click)="showFormData(item.contentId)">
                            <em class="fa fa-eye"></em>
                          </button>
                          <span *ngIf="item.STATUS!='2' && item.PRE_APPROVE!='1'">
                            <button class="btn btn-default btn-circle" *ngIf="RAC_EDIT_BN =='1'" type="button"
                              (click)="showFormData(item.contentId, true)">
                              <em class="fa fa-pencil"></em>
                            </button>
                          </span>
                        </td>
                        <td>{{item.pageName| uppercase}}</td>
                        <td>{{item.sectionName}}</td>
                        <td>
                          <ng-container *ngIf="item.isEarn == 0">UBR</ng-container>
                          <ng-container *ngIf="item.isEarn == 1">UBA</ng-container>
                        </td>
                        <td>{{item.isWeb == 1 ? 'Web' : 'Mobile'}}</td>
                        <td>
                          <div *ngIf="item.isActive == 0">
                            <span class="icls1">
                              <button class="btn commonbutt zol1">
                                Inactive
                              </button>
                              <span class="tooltiptext">Not Approved</span>
                            </span>
                          </div>
                          <div *ngIf="item.isActive == 1">
                            <span class="icls1">
                              <button class="btn  commonbutt zol" *ngIf="item.isActive == 1">
                                Active
                              </button>
                              <button class="btn  commonbutt zol1" *ngIf="item.isActive == 0">
                                Inactive
                              </button>
                              <span class="tooltiptext"> Approved </span>
                            </span>
                          </div>
                          <div *ngIf="item.APPROVAL_STATUS == 0 && item.PRE_APPROVE == 1">
                            <span class="icls1">
                              <button class="btn  commonbutt zol">
                                Active
                              </button>
                              <span class="tooltiptext"> Approved </span>
                            </span>
                          </div>
                          <div *ngIf="item.APPROVAL_STATUS == 2 && item.STATUS == 2">
                            <span class="icls5">
                              <button class="btn  commonbutt zol1">
                                Inactive
                              </button>
                              <span class="tooltiptext">Rejected</span>
                            </span>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                    <tfoot>
                      <tr>
                        <td colspan="6">
                          <pagination-controls (pageChange)="p = $event"></pagination-controls>
                        </td>
                      </tr>
                    </tfoot>
                  </table>
                </div>
                <div *ngIf="loader">
                  <div style="margin:auto; text-align: center">
                    <img src="../../../../assets/img/Loading_Animation.gif" width="8%" height="8%" alt="Loader">

                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div *ngIf="actionmode=='View'" class="searchdiv">
  <div class="card screen-wrapper">
    <div class="header headerdiv">
      <h1 class="screen-title" *ngIf="showList==!false">{{viewTitle}}</h1>
      <h1 class="screen-title" *ngIf="showList==false">{{insertDataTitleBN}}</h1>
      <div class="button-wrapper bothbuttdiv2">
        <div *ngIf="actionmode=='View'" class="btn back-button button-margin ">
          <button class="btn btn-danger commonbutt" (click)="searchForm()" type="button">
            <em class="fa fa-times"></em>&nbsp;Close</button>
        </div>
      </div>
    </div>
    <div class="card-body">
      <div class="row">
        <div class="col-md-12">
          <div class="form-div">
            <div class="row">
              <div class="m-portlet">
                <div>
                  <div>
                    <div>
                      <div class="tdive">
                        <table aria-describedby="bannerSearchDetails" class="viewtable">
                          <div *ngFor="let q of serachTableInfo">
                            <tr>
                              <th scope="col">
                                <span class="vlbl">Platform</span>
                              </th>
                              <td>
                                <span class="vVal">{{ q.isEarn == 1 ? 'UBA' : 'UBR' }}</span>
                              </td>
                            </tr>
                            <tr>
                              <th scope="col">
                                <span class="vlbl">Trip Type</span>
                              </th>
                              <td>
                                <span class="vVal">{{ q.isDomestic == 1 ? 'Domestic' : 'International' }}</span>
                              </td>
                            </tr>
                            <tr>
                              <th scope="col">
                                <span class="vlbl">Journey Type</span>
                              </th>
                              <td>
                                <span class="vVal">{{ q.isOneway == 1 ? 'One Way' : 'Return' }}</span>
                              </td>
                            </tr>
                            <tr>
                              <th scope="col">
                                <span class="vlbl">Display</span>
                              </th>
                              <td>
                                <span class="vVal">{{ q.pageName }}</span>
                              </td>
                            </tr>
                            <tr>
                              <th scope="col">
                                <span class="vlbl">Form Factor</span>
                              </th>
                              <td>
                                <span class="vVal">{{ q.isWeb == 1 ? 'Web' : 'Mobile' }}</span>
                              </td>
                            </tr>
                            <tr>
                              <th scope="col">
                                <span class="vlbl">Section Name</span>
                              </th>
                              <td>
                                <span class="vVal">{{ q.sectionName }}</span>
                              </td>
                            </tr>
                            <tr>
                              <th scope="col">
                                <span class="vlbl">Image</span>
                              </th>
                              <td>
                                <img [src]="getImage(q.imageURL)" width="100px" height="95px" alt="Loader">
                              </td>
                            </tr>
                            <tr>
                              <th scope="col">
                                <span class="vlbl">Content Heading</span>
                              </th>
                              <td>
                                <span class="vVal">{{ q.contentHeading }}</span>
                              </td>
                            </tr>
                            <tr>
                              <th scope="col">
                                <span class="vlbl">Content Sub Heading</span>
                              </th>
                              <td>
                                <span class="vVal">{{ q.contentSubHeading }}</span>
                              </td>
                            </tr>
                            <tr>
                              <th scope="col">
                                <span class="vlbl">Content Link</span>
                              </th>
                              <td>
                                <span class="vVal"><a [href]="q.linkURL" target="_blank">{{ q.linkURL }}</a></span>
                              </td>
                            </tr>
                            <tr>
                              <th scope="col">
                                <span class="vlbl">Content Image Alt</span>
                              </th>
                              <td>
                                <span class="vVal">{{ q.altImage }}</span>
                              </td>
                            </tr>
                            <tr>
                              <th scope="col">
                                <span class="vlbl">Content Position</span>
                              </th>
                              <td>
                                <span class="vVal">{{ q.position }}</span>
                              </td>
                            </tr>
                            <tr>
                              <th scope="col">
                                <span class="vlbl">Content Redirection</span>
                              </th>
                              <td>
                                <span class="vVal">{{ q.isNewTab ? 'New Tab' : 'Current Tab'}}</span>
                              </td>
                            </tr>
                            <tr>
                              <th scope="col">
                                <span class="vlbl">Active</span>
                              </th>
                              <td>
                                <span class="vVal">{{ q.isActive ? 'Active' : 'InActive' }}</span>
                              </td>
                            </tr>
                          </div>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>